// extracted by mini-css-extract-plugin
export default {"termsContainer":"Terms_termsContainer__akIsq"};